import { SubFormActionField } from 'schemaBuilder/types';
import { ConverterFieldPayload } from 'schemaBuilder/converter/types';
import { ResolvedExpressionType, StatementType } from '@stratumn/dsl';
import { JSONSchema7Definition } from 'json-schema';
import { key } from '../utils';

type MyProps = {
  properties: { [key: string]: JSONSchema7Definition };
  uiOptions: { order: string[] };
  uiOrder: string[];
  uiFields: any;
};

export default (
  field: SubFormActionField,
  convertSimples
): ConverterFieldPayload => {
  const {
    properties,
    uiOptions,
    uiOrder,
    uiFields
  } = field.schemaField.properties.reduce(
    (props: MyProps, prop) => {
      const item = convertSimples(prop);
      const id = key(prop);
      props.properties[id] = item.jsonSchema.properties[id];
      props.uiOrder.push(id);
      props.uiOptions.order.push(id);
      props.uiFields[id] = item.uiSchema[id];
      return props;
    },
    { properties: {}, uiOptions: { order: [] }, uiOrder: [], uiFields: {} }
  );

  return {
    jsonSchema: {
      type: 'object',
      properties: {
        [key(field)]: {
          type: 'array',
          title: field.schemaField.label,
          required: field.required
            ? field.schemaField.properties
                .filter(prop => prop.required)
                .map(prop => key(prop))
            : [],
          items: {
            type: 'object',
            properties
          }
        }
      },
      required: field.required ? [key(field)] : undefined
    },
    uiSchema: {
      'ui:order': [key(field)],
      [key(field)]: {
        items: {
          'ui:options': uiOptions,
          'ui:order': uiOrder,
          ...uiFields
        }
      }
    },
    effects: [
      {
        $tags: ['schemaBuilder'],
        $statement: StatementType.SetVariable,
        path: `state.data.${key(field)}`,
        value: {
          $expression: ResolvedExpressionType.Concat,
          arguments: [
            {
              $expression: ResolvedExpressionType.Variable,
              query: `state.data.${key(field)}`
            },
            {
              $expression: ResolvedExpressionType.Variable,
              query: `formData.${key(field)}`
            }
          ]
        }
      }
    ]
  };
};
